var e=(e,i)=>({shouldSerialize:e,serialize:i});export{e as makeCondition};
//# sourceMappingURL=makeCondition.js.map